import {createSignal, type Signal} from '@pexip/signal';

export interface SignalState<T> {
    get(): T;
    set(t: T): void;
    add: Signal<T, T>['add'];
    changed: boolean;
}

export const createSignalState = <T>(init: T): SignalState<T> => {
    const props = {
        state: init,
        signal: createSignal<T>(),
        changed: false,
    };

    return Object.freeze({
        get() {
            props.changed = false;
            return props.state;
        },
        set(t: T) {
            props.changed = true;
            props.state = t;
            props.signal.emit(t);
        },
        add: props.signal.add,
        get changed() {
            return props.changed;
        },
    });
};
